
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Inventory, InventoryUiClient, LinkMediaRequest, Media } from '../../../../backend/backendapi';
import { WindowType } from '../../../../../util';
import { initClient } from '../../../../../api';
import DropZone from '../../../../dropzone/DropZone';

declare var window: WindowType;

@Component({
  name: 'TabAttachments',
  components: {
    DropZone,
    ImageViewer: require('../../../../imageviewer/imageviewer.vue.html').default,
  },
})
export default class TabAttachments extends Vue {
  @Prop({ required: true })
  readonly inventory!: Inventory | null;
  readonly files: Media[] = [];

  private readonly service = initClient(InventoryUiClient);

  get canMediaDelete(): boolean {
    return window.application.permissions.media.delete;
  }

  async onDzComplete(file): Promise<void> {
    if (!this.inventory?.id) {
      return;
    }
    let response = JSON.parse(file.xhr.responseText);
    const inventoryMedia = await this.service.linkMedia(new LinkMediaRequest({ inventoryId: this.inventory.id, mediaId: response.fileId }));
    this.inventory.medias ??= [];
    this.inventory.medias.push(inventoryMedia);
    await this.fetchMedia(this.inventory.id);
  }

  @Watch('inventory')
  private async onInventoryChanged(newInventory: Inventory | null, oldInventory: Inventory | null): Promise<void> {
    if (!newInventory?.id) {
      this.files.splice(0);
    } else if (newInventory.id !== oldInventory?.id) {
      this.fetchMedia(newInventory.id!);
    } else {
      //inventory ids equal, do nothing
    }
  }
  
  private async fetchMedia(inventoryId: number): Promise<void> {
    this.files.splice(0);
    const media = await this.service.getMediasForInventoryId(inventoryId);
    if (this.inventory?.id === inventoryId) {//is the inventory still the same or did while async fetching the media?
      this.files.push(...media);
    }
  }
}
